export enum NPSRatingCategory {
  NOT_LIKELY = 'NOT_LIKELY',
  AVERAGE = 'AVERAGE',
  LIKELY = 'LIKELY'
}

export interface NPSLowRatingReason {
  name: string;
  value: string;
}
